import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import { Card, type CardProps } from '../Card/Card'
import * as tkns from './MessageCard.tokens'

export interface MessageCardProps extends CardProps {
  variant?: 'default' | 'warning' | 'error' | 'success' | 'upsell' | 'loading' | 'table'
}

export const MessageCard = styled(Card, {
  shouldForwardProp: youShallNotPass('variant'),
})<MessageCardProps>(({ theme, variant = 'default' }) => ({
  ...(variant === 'warning' && {
    backgroundColor: tkns.MessageCardColorWarningBackground,
    color: tkns.MessageCardColorWarningOnBackground,
  }),
  ...(variant === 'error' && {
    backgroundColor: tkns.MessageCardColorErrorBackground,
    color: tkns.MessageCardColorErrorOnBackground,
  }),
  ...(variant === 'upsell' && {
    backgroundColor: tkns.MessageCardColorUpsellBackground,
    color: tkns.MessageCardColorUpsellOnBackground,
  }),
  ...(variant === 'success' && {
    backgroundColor: tkns.MessageCardColorSuccessBackground,
    color: tkns.MessageCardColorSuccessOnBackground,
  }),
  ...(variant === 'loading' && {
    backgroundColor: theme.tokens.ThemeColorCommonBackground,
    color: theme.tokens.ThemeColorCommonOnSurfaceSecondary,
  }),
  ...(variant === 'table' && {
    border: `${tkns.MessageCardBorderWidthNormal} solid ${tkns.MessageCardColorInfoOutline}`,
    backgroundColor: tkns.MessageCardColorInfoBackground,
    color: tkns.MessageCardColorInfoOnBackground,
  }),
}))
